<template>
  <v-menu bottom left offset-x tile>
    <template #activator="{ on, attrs }">
      <v-btn
        icon
        outlined
        small
        text
        tile
        v-bind="attrs"
        v-on="on"
        :ripple="false"
        :disabled="!actions.length"
      >
        <v-icon v-text="'more_vert'" />
      </v-btn>
    </template>

    <v-list dense tile v-if="actions.length">
      <template v-for="(action, index) in actions">
        <v-divider
          v-if="action.divider"
          :key="`context-divider-${index}`"
          class="my-2"
        />

        <v-list-item
          v-if="action.label"
          :key="`context-item-${index}`"
          :to="action.to"
          :disabled="!!action.disabled"
          @click="$emit('click', action)"
        >
          <v-list-item-icon v-if="action.icon">
            <v-icon v-text="action.icon" />
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title v-text="action.label" />
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'pibot-context-menu',
  props: {
    actions: {
      type: Array,
      required: true
    }
  }
}
</script>
